"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import UITopBarSharedControls from "../ui/UITopBarSharedControls"

export default class SimpleScene extends P3.Scene {
    constructor() {
        super();

        // Attributes.
        this._uiTopBarSharedControls = null;
        this._bgSprite = null;
    }

    init() {
        super.init();
        //  P3.Scene.prototype.init.call(this);

        // Bg sprite.
        if (this._bgSprite != null) {
            this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
            this._bgSprite.position = new PIXI.Point(
                Common.STAGE_WIDTH * 0.5,
                Common.STAGE_HEIGHT * 0.5);
            this.addChild(this._bgSprite);
        }
    }

    createSharedControls() {
        // UITopBarSharedControls.
        this._uiTopBarSharedControls = new UITopBarSharedControls();
        this._uiTopBarSharedControls.init();
        this.addChild(this._uiTopBarSharedControls);
    }

    resize() {
        this.x = ( P3.View.width - Common.STAGE_WIDTH ) * 0.5;
        this._uiTopBarSharedControls.resize();
    }

    //no need to override if your just going to call super, but I added params and kill tweens so is necessary now
    destroy(params = {}) {
        params.children = true;
        super.destroy(params);
        TweenMax.killAll();
    }

    /**
     * @abstract
     * @param callback
     * @param scope
     */
    animateIn(callback, scope) {
        throw new Error('You have to implement the abstract method before use : ' + this.constructor.name + '#animateIn');
    }

    /**
     * @abstract
     * @param callback
     * @param scope
     */
    animateOut(callback, scope) {
        throw new Error('You have to implement the abstract method before use : ' + this.constructor.name + 'animateOut');
    }

    //strange pattern. why override parent function and do nothing..
    //// hide(callback, scope) {
    //  }

    get bg() {
        return this._bgSprite;
    }

}

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
/*
 function SimpleScene() {
 P3.Scene.call(this);


 // Attributes.
 this._uiTopBarSharedControls = null;
 this._bgSprite = null;
 }
 export default SimpleScene;
 //module.exports = SimpleScene;
 SimpleScene.prototype = Object.create(P3.Scene.prototype);
 SimpleScene.prototype.constructor = SimpleScene;
 */

//===================================================
//
// Public
//
//===================================================
/*
 SimpleScene.prototype.init = function () {
 P3.Scene.prototype.init.call(this);


 // Bg sprite.
 if (this._bgSprite != null) {
 this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
 this._bgSprite.position = new PIXI.Point(
 Common.STAGE_WIDTH * 0.5,
 Common.STAGE_HEIGHT * 0.5);
 this.addChild(this._bgSprite);
 }
 };
 */

/*
 SimpleScene.prototype.createSharedControls = function () {
 // UITopBarSharedControls.
 this._uiTopBarSharedControls = new UITopBarSharedControls();
 this._uiTopBarSharedControls.init();
 this.addChild(this._uiTopBarSharedControls);
 };
 */

/*
 SimpleScene.prototype.resize = function () {
 this.x = ( P3.View.width - Common.STAGE_WIDTH ) * 0.5;
 this._uiTopBarSharedControls.resize();
 };
 */
/*
 SimpleScene.prototype.destroy = function () {
 P3.Scene.prototype.destroy.call(this);
 };
 */
/*
 // Override.
 SimpleScene.prototype.animateIn = function (callback, scope) {
 };

 // Override.
 SimpleScene.prototype.animateOut = function (callback, scope) {
 };

 // Override.
 SimpleScene.prototype.hide = function (callback, scope) {
 };
 */

//===================================================
//
// Private
//
//===================================================

// TODO:


//===================================================
//
// Events
//
//===================================================

// TODO:


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    SimpleScene.prototype,
    "bg",
    {
        get: function () {
            return this._bgSprite;
        }
    });